<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <form @submit.prevent="applyFilter">
          <h6 class="heading-small text-muted mb-4">Search</h6>
          <div class="row">
            <div class="col">
              <a-input placeholder="Search by" v-model="search">
                <a-select
                  slot="addonAfter"
                  default-value="description"
                  style="width: 110px"
                  v-model="searchType"
                  @change="searchTypeOnChange"
                >
                  <a-select-option value="description">
                    <a-tooltip title="Description"> Description </a-tooltip>
                  </a-select-option>
                  <a-select-option value="code">
                    <a-tooltip title="Code"> Code </a-tooltip>
                  </a-select-option>
                </a-select>
              </a-input>
            </div>
          </div>
          <hr />

          <form role="form" @submit.prevent>
            <div>
              <div>
                <label>Membership Program</label>
              </div>
              <div class="row mb-3">
                <div class="col">
                  <a-select
                    v-model="table.filters.membership_program_id"
                    style="width: 100%"
                    placeholder="Select Membership Program"
                  >
                    <a-select-option :value="null">All</a-select-option>
                    <a-select-option
                      v-for="membershipProgram in options.membershipPrograms"
                      :value="membershipProgram.id"
                      :key="membershipProgram.id"
                      :label="membershipProgram.name"
                    >
                      {{ membershipProgram.name }}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </div>
            <div>
              <div>
                <label>Item Status</label>
              </div>
              <div class="row mb-3">
                <div class="col">
                  <a-select
                    v-model="table.filters.status_code"
                    style="width: 100%"
                    placeholder="Select Item Status"
                  >
                    <a-select-option :value="null">All</a-select-option>
                    <a-select-option value="A"> Active </a-select-option>
                    <a-select-option value="I"> Inactive </a-select-option>
                  </a-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-button
                  type="primary btn-block"
                  class="my-4"
                  @click.prevent="applyFilter"
                >
                  <div>Apply Filter</div>
                </base-button>
              </div>
            </div>
          </form>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
        >
          <template #headerButtons>
            <base-button
              id="new"
              class="float-right ml-1"
              type="primary"
              v-if="selectedActions.includes('Add')"
              size="sm"
              @click="openDrawer()"
              >+ Add Item</base-button
            >
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <ItemForm
                :viewMode="viewMode"
                :itemData="itemData"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{ tableProps }">
            <button
              id="view"
              class="btn btn-success btn-sm"
              v-if="selectedActions.includes('View')"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
            </button>
            <button
              id="edit"
              class="btn btn-warning btn-sm"
              v-if="selectedActions.includes('Edit')"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              Edit
            </button>
            <a-popconfirm
              title="You are about to delete this record?"
              v-if="selectedActions.includes('Delete')"
              @confirm="deleteRow(tableProps.rowData)"
              okText="Delete"
              cancelText="Cancel"
            >
              <a class="btn btn-danger btn-sm text-white">Delete</a>
            </a-popconfirm>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import ItemForm from './ItemForm.vue';
import HTTPRequest from '../../controllers/httpRequest';
import { mapGetters } from 'vuex';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    ItemForm
  },
  data() {
    return {
      searchType: 'description',
      search: null,
      gradientType: 'gradient-purple',
      itemData: null,
      drawer: {
        visible: false,
        width: 480,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Item Rewards',
        apiUrl: '/api/v1/clp_items',
        fields: [
          'actions',
          { name: 'code', title: 'Code' },
          {
            name: 'itemMembershipLevels',
            title: 'Membership Level',
            formatter(membershipLevels) {
              if (membershipLevels.length) {
                let response = [];
                for (let i = 0; i < membershipLevels.length; i++) {
                  response.push(membershipLevels[i].name);
                }
                return response.join(', ');
              } else {
                return null;
              }
            }
          },
          { name: 'points_to_redeem', title: 'Points Required' },
          { name: 'description', title: 'Description' },
          { name: 'status', title: 'Status' }
        ],
        filters: {
          filter: false,
          status_code: 'A',
          code: null,
          description: null
        }
      },
      options: {
        membershipPrograms: []
      },
      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      }
    };
  },
  methods: {
    searchTypeOnChange() {
      this.table.filters = {
        status_code: null,
        code: null,
        description: null
      };
      this.table.filters[this.searchType] = this.search;
    },
    openDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.itemData = rowData;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.itemData = null;
    },

    applyFilter() {
      if (
        this.table.filters['status_code'] == null &&
        this.table.filters['code'] == null &&
        this.table.filters['description'] == null
      ) {
        this.table.filters.filter = false;
      } else {
        this.table.filters.filter = true;
      }
      this.setFilter();
    },
    setFilter() {
      this.$root.$emit('refreshTable');
    },

    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs',
        { per_page: 1000 }
      );
      this.options.membershipPrograms = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
    async deleteRow(rowData) {
      const messageId = rowData.id;
      const response = await HTTPRequest.deleteRequest(
        `/api/v1/clp_items/${messageId}`,
        {
          item: {
            item_id: messageId,
            membership_program_id: rowData.membership_program_id
          }
        }
      );

      if (response.message == 'Success') {
        this.$notification.success({
          message: 'Success'
        });
        this.$root.$emit('refreshTable');
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  created() {
    this.getMembershipPrograms();
    this.$store.dispatch('setCurrentModule', 'ItemRewards');
  },

  watch: {
    search(val) {
      if (val == '') {
        this.search = null;
      } else {
        this.table.filters.filter = true;
        this.table.filters[this.searchType] = val;
      }
    }
  }
};
</script>

<style scoped></style>
